<template>
  <div>
    <el-dialog
      title="借款审批"
      :visible.sync="loanApprovalVisible"
      width="50%"
      top="50px"
      @close="closeApprovalDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="loan-detail-box">
        <div class="detail-title">借款详情</div>
        <el-descriptions :column="2" border size="medium">
          <el-descriptions-item label="申请单编号">
            {{ loanApprovalInfo.applyCode }}
          </el-descriptions-item>
          <el-descriptions-item label="商机名称">
            {{ loanApprovalInfo.chanceName }}
          </el-descriptions-item>
          <el-descriptions-item label="借款人">
            {{ loanApprovalInfo.loanManName }}
          </el-descriptions-item>
          <el-descriptions-item label="借款类型">
            {{ loanApprovalInfo.loanTypeName }}
          </el-descriptions-item>
          <el-descriptions-item label="借款数额">
            <span class="amount-text">￥{{ formatAmount(loanApprovalInfo.amount) }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="所属部门">
            {{ loanApprovalInfo.departmentName }}
          </el-descriptions-item>
          <el-descriptions-item label="借款申请时间">
            {{ loanApprovalInfo.loanApplyTime }}
          </el-descriptions-item>
          <el-descriptions-item label="借款状态">
            <el-tag :type="getTagType(loanApprovalInfo.state)">
              {{ loanApprovalInfo.stateName }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="借款理由" :span="2">
            {{ loanApprovalInfo.reason }}
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="loanApprovalHandle(2)">驳回</el-button>
        <el-button type="primary" @click="loanApprovalHandle(1)"
          >通过</el-button
        >
      </span>
    </el-dialog>

    <el-tabs type="card" v-model="func" @tab-click="tabClick">
      <el-tab-pane :label="tabTitle" name="0">
        <myLoan />
      </el-tab-pane>
      <el-tab-pane label="未审批" name="2" v-if="approvelPrivileges">
      </el-tab-pane>
      <el-tab-pane label="已审批" name="1" v-if="approvelPrivileges">
      </el-tab-pane>
    </el-tabs>

    <template v-if="func != 0">
      <div class="queryRow">
        <el-date-picker
          class="dataPicker"
          v-model="queryForm.rqScope"
          type="daterange"
          value-format="yyyy-MM-dd"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          clearable
          @change="onDateChange"
        >
        </el-date-picker>

        <el-input
          clearable
          prefix-icon="el-icon-search"
          v-model="queryForm.chanceName"
          placeholder="请输入商机名称"
          @clear="search"
          style="width: 200px; margin: 0 20px"
        >
        </el-input>

        <el-input
          clearable
          prefix-icon="el-icon-search"
          v-model="queryForm.loanManName"
          placeholder="请输入借款人姓名"
          @clear="search"
          style="width: 200px; margin: 0 20px"
        >
        </el-input>

        <el-button type="primary" icon="el-icon-search" @click="search">
          搜索
        </el-button>
      </div>

      <div class="loanList">
        <el-table
          v-loading="loading"
          style="margin-bottom: 20px; height: 65vh; overflow: auto"
          class="table"
          :data="tableData"
          stripe
          border
        >
          <el-table-column
            align="center"
            prop="applyCode"
            label="申请单编号"
            width="180"
          >
          </el-table-column>

          <el-table-column align="center" prop="chanceName" label="商机名称">
          </el-table-column>

          <el-table-column
            align="center"
            prop="loanManName"
            label="借款人"
            width="180"
          >
          </el-table-column>

          <el-table-column align="center" prop="amount" label="借款数额">
            <template slot-scope="scope">
              <span>￥{{ formatAmount(scope.row.amount) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" prop="reason" label="借款理由">
          </el-table-column>

          <el-table-column
            align="center"
            prop="loanApplyTime"
            label="借款申请时间"
          
          min-width="130"
          
          :formatter="dateTimeTwoLine"
          class-name="cell-two-line"
          >
          </el-table-column>

          <el-table-column align="center" prop="stateName" label="借款状态">
            <template slot-scope="scope">
              <el-tag :type="getTagType(scope.row.state)">{{
                scope.row.stateName
              }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="departmentName"
            label="借款人所属部门"
          >
          </el-table-column>

          <el-table-column
            align="center"
            prop=""
            v-if="queryForm.func == '2'"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="openDialog(scope.row)"
                >立即审批</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="approvalResultName"
            v-if="queryForm.func == '1'"
            label="审批结果"
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.approvalResult == 1 ? 'success' : 'danger'"
                >{{ scope.row.approvalResultName }}</el-tag
              >
            </template>
          </el-table-column>


        </el-table>

        <!-- 分页 -->
        <div style="display: flex; justify-content: flex-end; margin-top: 5px">
          <el-pagination
            :current-page="queryForm.page"
            @current-change="onCurrentChange"
            @size-change="onSizeChange"
            background
            :total="total"
            :page-size="queryForm.limit"
            layout="sizes, prev, pager, next, jumper, ->, total"
          >
          </el-pagination>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { comdify } from '@/utils/money.js';
import { getLoanApprovalList, loanApproval } from '@/api/finance/loan.js';
import myLoan from './myLoan.vue';
export default {
  data() {
    return {
      isFinance: "", // 判断角色身份是否为财务
      approvelPrivileges: false, // 审批权限
      func: 0, // 0: 我的借款；1: 已审批；2: 待审批；
      loanApprovalInfo: {}, // 审批信息
      loading: false, //表格加载
      total: 0, // 数据总条数
      queryForm: {
        page: 1, // 当前页码
        limit: 10, // 每页显示条数
        func: 0, // 1: 已审批；2: 待审批；
        rqScope: "", // 日期范围
        loanManName: "", // 借款人姓名
        chanceName: "", // 商机名称
      },
      tableData: [], //表格数据
      loanApprovalVisible: false, //审批弹框
      tabTitle: "", // 借款标题
    };
  },
  components: {
    myLoan,
  },
  created() {
    this.isFinance = sessionStorage.getItem("userRoleId") == 27; // 判断角色身份是否为财务还是申请人
    this.tabTitle = this.isFinance ? "借款列表" : "我的借款";
    // this.getTableData();
    const qxRoleIdList = [1, 2, 8, 26, 29, 34, 38, 43, 44, 48, 54, 58, 59];
    // 2	销售
    // 8	总经理
    // 26	集成部经理
    // 29	人力资源部总监
    // 34	数据智研部经理
    // 38	数据库服务部经理
    // 43	数据安全服务部经理
    // 44	售前服务部经理
    // 48	行政总监
    // 54 CTO
    // 58 智维产品部经理
    // 59 项目监理部经理
    this.approvelPrivileges = qxRoleIdList.includes(
      sessionStorage.getItem("userRoleId") * 1
    );
  },
  computed: {},
  methods: {
    // 根据借款状态区分tag type
    getTagType(state) {
      switch (state) {
        case 1: // 1.已提交申请
        case 5: // 5.已付款
        case 6: // 6.已还款
        case 9: // 9.无需审批
          return "";
        case 2: // 2.审批完成
          return "success";
        case 3: // 3.申请失败(已驳回)
        case 4: // 4. 已撤回
          return "danger";
        default:
          return "";
      }
    },
    formatAmount(amount) {
      return comdify(amount);
    },
    getTableData() {
      this.loading = true;
      const queryObj = {
        page: this.queryForm.page,
        limit: this.queryForm.limit,
        func: this.queryForm.func, // 1: 已审批；2: 待审批；
      };
      this.queryForm.rqScope[0]
        ? (queryObj.rqScope =
            this.queryForm.rqScope[0] + "," + this.queryForm.rqScope[1])
        : "";
      this.queryForm.loanManName
        ? (queryObj.loanManName = this.queryForm.loanManName)
        : "";
      this.queryForm.chanceName
        ? (queryObj.chanceName = this.queryForm.chanceName)
        : "";
      getLoanApprovalList(queryObj).then((res) => {
        if (res.code == 200) {
          this.total = res.count; // 数据总条数
          this.tableData = res.data;
          this.loading = false;
        }
      });
    },
    tabClick(tab) {
      // 点击tab
      if (this.func != 0) {
        // 如果当前tab和当前选中的tab相同，不做任何操作
        this.queryForm.page = 1;
        this.queryForm.func = this.func;
        this.getTableData();
      }
    },
    // 当前页改变回调
    onCurrentChange(page) {
      this.queryForm.page = page; // 修改当前页码
      this.getTableData(); // 刷新表格数据
    },
    // 每页显示条数改变回调
    onSizeChange(size) {
      this.queryForm.page = 1;
      this.queryForm.limit = size; // 修改每页显示条数
      this.getTableData(); // 刷新表格数据
    },
    onDateChange(e) {
      if (!e) this.queryForm.rqScope = [];
      this.queryForm.page = 1;
      this.getTableData(); // 刷新表格数据
    },
    search() {
      // 搜索
      this.queryForm.page = 1;
      this.getTableData(); // 刷新表格数据
    },
    openDialog(row) {
      // 打开审批弹框
      this.loanApprovalInfo = row;
      this.loanApprovalVisible = true;
    },
    loanApprovalHandle(approvalResult) {
      // 提交审批
      loanApproval({
        applyCode: this.loanApprovalInfo.applyCode,
        approvalType: 3,
        approvalResult: approvalResult, // 1: 审批通过；2: 审批驳回
      }).then((res) => {
        // 提交审批
        if (res.code == 200) {
          // 提交成功
          this.loanApprovalVisible = false; // 关闭审批弹框
          this.getTableData(); // 刷新表格数据
          this.$message({
            message: "审批成功",
            type: "success",
          });
        }
      });
    },
    // 关闭弹框重置数据
    closeApprovalDialog() {
      this.loanApprovalInfo = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  ::v-deep .el-table__cell {
    > :empty::before {
      content: "--";
      color: gray;
    }
  }
}
.queryRow {
  margin-bottom: 20px;

  .queryName {
    width: 300px;
    margin-right: 10px;
  }

  .dataPicker {
    margin-right: 10px;
  }
}
.loan-detail-box {
  .detail-title {
    font-size: 16px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 12px;
    padding-left: 10px;
    border-left: 3px solid #409eff;
  }
  .amount-text {
    font-weight: bold;
    color: #f56c6c;
    font-size: 16px;
  }
}
</style>
